module.exports = __webpack_public_path__ + "static/media/Artboard6.3a23a3f2.png";